import React from "react";
import useTableFilters from "@/hooks/useTableFilters";
import {
  SalesCoordinatorFilter,
  ProjectFilter,
  TypeFilter,
  DateFilter,
  FilterActions,
  CompanyFilter,
  AccountManagerFilter,
} from "../components/company-filters";

export default function CancelledFilters({
  filters,
  setFilters,
  setIsOpen,
  isOpen,
  clearFilters,
  defaultFilters,
}) {
  const {
    localFilters,
    applyFilters,
    clearLocalFilters,
    handleSetLocalFilters,
  } = useTableFilters({
    filters,
    setFilters,
    setIsOpen,
    clearFilters,
    initialFilters: {
      sales_coordinator: undefined,
      type: undefined,
      project: undefined,
      billing_date: undefined,
      ...defaultFilters,
    },
  });
  return (
    <div className="w-full p-4 space-y-4">
      <AccountManagerFilter
        localFilters={localFilters}
        handleSetLocalFilters={handleSetLocalFilters}
        isOpen={isOpen}
      />
      
      <SalesCoordinatorFilter
        localFilters={localFilters}
        handleSetLocalFilters={handleSetLocalFilters}
        isOpen={isOpen}
      />

      <ProjectFilter
        localFilters={localFilters}
        handleSetLocalFilters={handleSetLocalFilters}
        isOpen={isOpen}
      />

      <TypeFilter
        localFilters={localFilters}
        handleSetLocalFilters={handleSetLocalFilters}
      />

      <DateFilter
        fieldName="date_updated"
        label="Updated At"
        localFilters={localFilters}
        handleSetLocalFilters={handleSetLocalFilters}
      />

      <CompanyFilter
        localFilters={localFilters}
        handleSetLocalFilters={handleSetLocalFilters}
      />

      <FilterActions
        applyFilters={applyFilters}
        clearLocalFilters={clearLocalFilters}
      />
    </div>
  );
}
